export default __webpack_public_path__ + "static/foxi-c13fd08fee44ca5a184cc3d3cc6dfc71.jpg";